export const X_PLATFORMS = {
  dashboard: 'dashboard',
  extension: 'extension',
  mobile: 'mobile',
};
